module.exports = /** @type {const} */ ({
    parent: 'parent',
    parentProperty: 'parentProperty',
    path: 'path',
    pointer: 'pointer',
    value: 'value'
});
